<template>
	<div class="task-calendar-item-container">
		<v-row no-gutters class="ma-0 px-3">
			<v-col cols="11">
				<div>
					<div class="task-calendar-item-name" style="color: #65A3C1">{{ timesheet.task ? timesheet.task.display_name:timesheet.kind.display_name }}</div>
					<span class="task-calendar-item-text task-calendar-item-color-sub task-calendar-item-main">{{ timesheet.job.code }}</span>&nbsp;&nbsp;
					<span class="task-calendar-item-text task-calendar-item-color-sub  task-calendar-item-sub">{{ timesheet.job.display_name}}</span>
				</div>
				<div v-if="timesheet.phase && timesheet.phase.display_name.length !== 0">
					<span class="task-calendar-item-text task-calendar-item-color-sub task-calendar-item-main">Phase:</span>&nbsp;&nbsp;
					<span class="task-calendar-item-text task-calendar-item-color-sub  task-calendar-item-sub">{{ timesheet.phase.display_name }}</span>
				</div>
			</v-col>
			<v-col cols="1">
				<v-btn x-small icon :disabled="!privileges.includes(Ts)" @click.stop="$emit('duplicate', timesheet)">
					<v-icon color="rgba(25, 42, 62, 0.5)" size="18">mdi-content-copy</v-icon>
				</v-btn>
				<CalendarItemMenu
					v-if="timesheet.job_valid"
					@click.stop
					:type="event_timesheet"
					:color="'rgba(25, 42, 62, 0.5)'"
					:privileges="privileges"
					@click-menu-item="$emit('click-menu-item', $event)"
					@delete="$emit('delete')"/>
			</v-col>
		</v-row>
		<v-divider class="mx-2"></v-divider>
		<div class="px-3">
			<span class="task-calendar-item-text task-calendar-item-main" style="color: #65A3C1">{{ timesheet.notes }}</span>
		</div>
		<div class="px-3">
			<span class="task-calendar-item-text task-calendar-item-main" style="color: #65A3C1">Logged:</span>&nbsp;&nbsp;
			<span class="task-calendar-item-text task-calendar-item-sub" style="color: #65A3C1; font-weight: 700">{{ timesheet.duration_fmt }}</span>
		</div>
	</div>
</template>
<script>
import CalendarItemMenu from "@/views/timesheets/calendar_item_menu.vue";

/* If selected, user will only be allow to amend items their own timesheets */
const TS = 'TS';

/* If selected, the user is allowed to delete timesheet entries */
const TsD = 'TsD';

const Event_Timesheet = 'timesheet';

export default {
	name: 'CalendarTimesheetItem',
	props: {
		timesheet: {
			type: Object,
			default: () => {}
		},
		privileges: {
			type: Array,
			default: () => []
		},
	},
	components: {
		CalendarItemMenu
	},
	data() {
		this.event_timesheet = Event_Timesheet;
		this.Ts = TS;
		this.TsD = TsD;
		return {}
	},
}
</script>
<style lang="scss" scoped>
.task-calendar-item-container {
  width: 100%;
	height: 100%;
  background: #FFFFFF;
  border: 1px solid rgba(25, 42, 62, 0.3);
  box-shadow: 0px 2px 4px rgba(25, 42, 62, 0.12);
  border-radius: 4px;
}
.task-calendar-timeline {
	height: 8px;
	background-color: #DADADA;
	border-radius: 4px 4px 0 0 ;
}
.task-calendar-item-row {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
}
.task-calendar-item-column {
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: flex-start;
}
.task-calendar-item-name {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #192A3E;
}
.task-calendar-item-text {
  font-family: 'Roboto';
  font-style: normal;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 0.4px;
}
.task-calendar-item-main {
  font-weight: 500;
}
.task-calendar-item-sub {
  font-weight: 400;
}
.task-calendar-item-color-main {
  color: #192A3E;
}
.task-calendar-item-color-sub {
  color: rgba(25, 42, 62, 0.5);
}
</style>